import { WhmBox } from "@securitize/reactjs-whm";
import { SxProps } from "@mui/material";

/**
 * @see https://whm.design.securitize.io/?path=/docs/assets-icons-general--docs
 */
function WhmLegacyIcon({ icon, sx }: { icon: string; sx?: SxProps }) {
  return (
    <WhmBox
      component="i"
      className={`wh-icon wh-icon-${icon} wh-text-h2-mobile`}
      sx={sx}
    />
  );
}

export default WhmLegacyIcon;
